/* The LOS Marine price, from numbers. Everything a reader can add up – module sums, discounts, the first year,
   the 50/40/10 payment plan – is computed here once, so the web page and the PDF can never show two different truths.
   Amounts are whole kroner eks. mva. Thousands are grouped with a no-break space (never wraps inside a number). */

const NB = "\u00a0";

/** 149000 → «149 000» */
export const num = (n) => Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, NB);

/** 149000 → «149 000 kr» */
export const nok = (n) => `${num(n)}${NB}kr`;

const sum = (xs) => xs.reduce((a, b) => a + b, 0);

/**
 * @param modules        [{ key, list, offer, monthly }]  – standalone prices per module
 * @param packageMonthly licence per month when both modules are taken together (the package price)
 * @param split          payment plan for the one-off, in percent (must add up to 100)
 * @param months         licence months counted in «the first year»
 */
export function priceModel({ modules, packageMonthly, split, months = 12 }) {
  if (sum(split) !== 100) throw new Error(`Betalingsplanen må summere til 100 % (er ${sum(split)} %)`);
  const list = sum(modules.map((m) => m.list));
  const offer = sum(modules.map((m) => m.offer));
  const monthlySeparate = sum(modules.map((m) => m.monthly));
  const monthly = packageMonthly;
  const introDiscount = list - offer;
  const packageDiscount = monthlySeparate - monthly;
  if (packageDiscount < 0) throw new Error("Pakkeprisen for lisens kan ikke være høyere enn modulene hver for seg");
  const licenceYear = monthly * months;
  const firstYear = offer + licenceYear;
  /* rounding never leaks: the last instalment takes what is left, so the plan always adds up to the offer */
  const payments = split.map((pct) => Math.round((offer * pct) / 100));
  payments[payments.length - 1] = offer - sum(payments.slice(0, -1));
  return {
    modules: modules.map((m) => ({ ...m, discount: m.list - m.offer })),
    list,
    offer,
    monthlySeparate,
    monthly,
    introDiscount,
    packageDiscount,
    months,
    licenceYear,
    firstYear,
    split,
    payments,
  };
}
